@if (manager.contentState() === 'none') {
  <albert-ch-cta-btn/>
} @else if (manager.contentState() === 'view' || manager.contentState() === 'edit' || manager.contentState() === 'create') {
  <albert-ch-display/>
}
